
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function About() {
  const values = [
    {
      icon: 'ri-award-line',
      title: 'Kalite',
      description: 'Her üretim aşamasında en yüksek kalite standartlarını uyguluyoruz.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'İnovasyon',
      description: 'Sürekli araştırma ve geliştirme ile sektöre yön veriyoruz.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Müşteri Odaklılık',
      description: 'Müşteri memnuniyeti bizim için en önemli başarı kriteri.'
    },
    {
      icon: 'ri-time-line',
      title: 'Güvenilirlik',
      description: 'Zamanında teslimat ve sürekli destek ile güven veriyoruz.'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.7), rgba(15, 23, 42, 0.7)), url('https://readdy.ai/api/search-image?query=Modern%20industrial%20manufacturing%20facility%20with%20precision%20machinery%20and%20steel%20production%20equipment%2C%20professional%20engineering%20workspace%20with%20organized%20tools%20and%20fasteners%2C%20high-tech%20manufacturing%20environment%20with%20clean%20lines%20and%20metallic%20surfaces%2C%20industrial%20photography%20with%20dramatic%20lighting&width=1920&height=600&seq=about-hero&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-4 text-center text-white">
            <h1 
              className="text-5xl md:text-6xl font-bold mb-6"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              Hakkımızda
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              Mühendislik ilkeleriyle üreten, kaliteyi standart haline getiren bir marka
            </p>
          </div>
        </section>

        {/* Company Story */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 
                  className="text-4xl font-bold text-slate-800 mb-6"
                  style={{ fontFamily: 'Exo 2, sans-serif' }}
                >
                  NBA Cıvata Hikayesi
                </h2>
                <div className="space-y-4 text-gray-600 leading-relaxed">
                  <p>
                    NBA Cıvata, endüstriyel bağlantı elemanları sektöründe uzun yıllardır faaliyet gösteren, 
                    güvenilir tedarik çözümleri sunan köklü bir markadır. Kuruluşumuzdan bu yana, 
                    kaliteyi standart haline getirme misyonuyla hareket ediyoruz.
                  </p>
                  <p>
                    Somun, cıvata, vida, rondela ve ankraj sistemleri tedarikinde uzmanlaşan firmamız, 
                    endüstriyel çözümler sunarak müşterilerimizin ihtiyaçlarına uygun bağlantı elemanlarını 
                    hızlı ve güvenilir şekilde temin etmektedir.
                  </p>
                  <p>
                    Geniş ürün yelpazemiz ve güçlü tedarik ağımızla uzun ömürlü ve güvenilir bağlantılar sağlar, 
                    müşteri memnuniyetini en üst düzeyde tutmayı hedefliyoruz.
                  </p>
                </div>
              </div>
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20industrial%20engineer%20inspecting%20high%20quality%20steel%20bolts%20and%20fasteners%20in%20modern%20manufacturing%20facility%2C%20precision%20quality%20control%20process%2C%20technical%20expertise%20and%20craftsmanship%2C%20clean%20organized%20workspace%20with%20professional%20lighting%20and%20metallic%20surfaces&width=600&height=400&seq=company-story&orientation=landscape"
                  alt="NBA Cıvata Üretim"
                  className="w-full rounded-lg shadow-lg object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 
                className="text-4xl font-bold text-slate-800 mb-4"
                style={{ fontFamily: 'Exo 2, sans-serif' }}
              >
                Değerlerimiz
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Güçlü, dayanıklı ve endüstriyel kimliğimizi oluşturan temel değerler
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div 
                  key={index}
                  className="bg-white p-8 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <i className={`${value.icon} text-2xl text-orange-500`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800 mb-4">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="bg-slate-800 text-white p-12 rounded-lg">
                <h3 
                  className="text-3xl font-bold mb-6"
                  style={{ fontFamily: 'Exo 2, sans-serif' }}
                >
                  Misyonumuz
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  Endüstriyel bağlantı elemanları sektöründe güvenilir tedarik çözümleri sunarak, 
                  müşterilerimize en yüksek kalitede, hızlı ve ekonomik ürün tedariki sağlamak. 
                  Sürekli gelişen ürün portföyümüz ve güçlü tedarik ağımızla sektöre değer katmak.
                </p>
              </div>

              <div className="bg-orange-500 text-white p-12 rounded-lg">
                <h3 
                  className="text-3xl font-bold mb-6"
                  style={{ fontFamily: 'Exo 2, sans-serif' }}
                >
                  Vizyonumuz
                </h3>
                <p className="text-orange-100 leading-relaxed">
                  Türkiye'nin ve bölgenin önde gelen endüstriyel bağlantı elemanları tedarikçisi olmak. 
                  Kalite, güvenilirlik ve müşteri memnuniyeti ile sektörde referans tedarikçi haline gelmek. 
                  Geniş ürün yelpazesi ve hızlı teslimat kapasitemizle uluslararası pazarlarda da tanınan bir marka olmak.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-slate-800 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 
              className="text-4xl font-bold mb-6"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              Bizimle Çalışmaya Hazır Mısınız?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Endüstriyel projeleriniz için güvenilir bağlantı elemanları ve profesyonel destek
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/iletisim">
                <Button size="lg" className="w-full sm:w-auto">
                  İletişime Geç
                </Button>
              </Link>
              <Link to="/urunler">
                <Button variant="outline" size="lg" className="w-full sm:w-auto">
                  Ürünleri İncele
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
